(function () {
  'use strict';
  function build() {
    if (document.documentElement.dataset.rfDetailsBuilt === '1') { return; }
    var root = document.querySelector('.product--columns') || document.querySelector('.product.featured-product');
    if (!root) { return; }
    document.documentElement.dataset.rfDetailsBuilt = '1';
    document.querySelectorAll('.rf-bullets, .rf-details-section, .rf-personalise-cta').forEach(function (el) { el.remove(); });
    var titleWrap = root.querySelector('.product__title');
    // 1. Bullets
    var bullets = window.rfProductBullets;
    if (titleWrap && Array.isArray(bullets) && bullets.length) {
      var box = document.createElement('div');
      box.className = 'rf-bullets';
      var ul = document.createElement('ul');
      bullets.forEach(function (point) {
        if (!point) { return; }
        var li = document.createElement('li');
        var mark = document.createElement('span');
        mark.className = 'rf-check';
        mark.innerHTML = '&#10003;';
        var text = document.createElement('span');
        text.textContent = point;
        li.appendChild(mark);
        li.appendChild(text);
        ul.appendChild(li);
      });
      box.appendChild(ul);
      titleWrap.insertAdjacentElement('afterend', box);
    }
    // 2. Hide redundant Description accordion
    var detailsEls = root.querySelectorAll('.product__accordion details, product-accordion details, .accordion details');
    detailsEls.forEach(function (el) {
      var summary = el.querySelector('summary');
      var label = summary ? summary.textContent.trim().toLowerCase() : '';
      if (label === 'description') { el.style.display = 'none'; }
    });
    // 3. Full description at bottom
    var html = window.rfProductDescriptionHTML;
    if (html && String(html).trim()) {
      var section = document.createElement('div');
      section.className = 'rf-details-section';
      section.innerHTML =
        '<h2 class="heading title-sm rf-details-heading">The Details</h2>' +
        '<div class="rte rf-details-copy">' + html + '</div>';
      root.insertAdjacentElement('afterend', section);
    }
    // 4. MRP label
    document.querySelectorAll('.price__was').forEach(function (el) {
      if (el.dataset.rfMrpLabelled === '1') { return; }
      el.dataset.rfMrpLabelled = '1';
      var label = document.createElement('span');
      label.className = 'rf-mrp-label';
      label.textContent = 'MRP ';
      el.insertBefore(label, el.firstChild);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
